import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all subAdmins
export const getSubAdmins = async () => {
  try {
    const response = await api.get(`${API_URL}/role`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Add a new subAdmin
export const addSubAdmin = async (subAdmin) => {
  try {
    const response = await api.post(`${API_URL}/role`, subAdmin,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Update a subAdmin
export const updateSubAdmin = async (id, subAdmin) => {
  try {
    const response = await api.put(`${API_URL}/role/${id}`, subAdmin,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Update an astrologer status
export const updateSubAdminStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/role/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Delete a subAdmin
export const deleteSubAdmin = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/role/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};



// Download backup 
export const downloadBackup = async () => {
  try {
    const response = await api.get(
      `${API_URL}/backup/download`,
      {
        responseType: "blob", 
      }
    );

    return response;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};